import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=797a9ef6&scoped=true"
import script from "./Change.vue?vue&type=script&lang=js"
export * from "./Change.vue?vue&type=script&lang=js"
import style0 from "./Change.vue?vue&type=style&index=0&id=797a9ef6&prod&lang=less&scoped=true"
import style1 from "./Change.vue?vue&type=style&index=1&id=797a9ef6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797a9ef6",
  null
  
)

export default component.exports